const matLanguageComprehension = [
  {
    id: 1,
    passageId: "rc1",
    passage: `Remote work, once considered a temporary pandemic-era measure, has settled into a permanent fixture of many industries. Surveys consistently show that employees value the autonomy it provides, yet managers report difficulty maintaining team cohesion across distributed workforces. The tension between individual flexibility and collective coordination remains unresolved, with companies experimenting with hybrid models that satisfy neither camp fully.`,
    question: "According to the passage, what is the central tension described?",
    options: [
      "A. Cost savings versus office rent",
      "B. Individual flexibility versus collective team coordination",
      "C. Productivity versus employee happiness",
      "D. Technology versus tradition"
    ],
    answer: "B"
  },
  {
    id: 2,
    passageId: "rc1",
    question: "The word 'unresolved' in the passage suggests that:",
    options: [
      "A. Companies have found a clear solution",
      "B. The issue is no longer relevant",
      "C. A satisfactory answer has not yet been found",
      "D. Employees have stopped caring about the issue"
    ],
    answer: "C"
  },
  {
    id: 3,
    question: "Choose the word closest in meaning to CANDID.",
    options: ["A. Deceptive", "B. Frank", "C. Reserved", "D. Cautious"],
    answer: "B"
  },
  {
    id: 4,
    question: "Choose the antonym of AUSTERE.",
    options: ["A. Lavish", "B. Strict", "C. Plain", "D. Harsh"],
    answer: "A"
  },
  {
    id: 5,
    question: "Fill in the blank: She has been living in Mumbai _____ 2015.",
    options: ["A. for", "B. since", "C. from", "D. during"],
    answer: "B"
  },
  {
    id: 6,
    question: "Which sentence is grammatically correct?",
    options: [
      "A. Each of the students have submitted their assignment.",
      "B. Each of the students has submitted his assignment.",
      "C. Each of the student has submitted their assignment.",
      "D. Each of the students has submit their assignment."
    ],
    answer: "B"
  },
  {
    id: 7,
    question: "Choose the correctly spelt word.",
    options: ["A. Occurence", "B. Occurrance", "C. Occurrence", "D. Ocurrence"],
    answer: "C"
  },
  {
    id: 8,
    question: "Choose the one-word substitute for 'a person who can speak two languages'.",
    options: ["A. Linguist", "B. Bilingual", "C. Polyglot", "D. Interpreter"],
    answer: "B"
  },
  {
    id: 9,
    passageId: "rc2",
    passage: `Urban planners have increasingly turned to tree-lined streets and pocket parks as tools for lowering city temperatures rather than mere aesthetic choices. Studies from several metropolitan areas indicate that neighborhoods with dense canopy cover experience noticeably lower peak summer temperatures than those dominated by concrete and asphalt. Despite this evidence, budget allocations for urban greening often lag behind spending on infrastructure projects perceived as more urgent, leaving many low-income neighborhoods with sparse tree cover and correspondingly higher heat exposure.`,
    question: "What is the main idea of the passage?",
    options: [
      "A. Trees are planted mainly to make cities look attractive",
      "B. Urban greening helps cool cities but often receives lower funding priority than infrastructure",
      "C. Concrete and asphalt are better for city temperatures than trees",
      "D. All neighborhoods currently have equal tree cover"
    ],
    answer: "B"
  },
  {
    id: 10,
    passageId: "rc2",
    question: "According to the passage, which neighborhoods tend to have less tree cover?",
    options: [
      "A. Neighborhoods near parks",
      "B. Low-income neighborhoods",
      "C. Neighborhoods with new infrastructure",
      "D. Coastal neighborhoods"
    ],
    answer: "B"
  },
  {
    id: 11,
    passageId: "rc2",
    question: "The word 'canopy' as used in the passage is closest in meaning to:",
    options: [
      "A. An umbrella structure",
      "B. A covering formed by tree branches and leaves",
      "C. A type of tent",
      "D. The roof of a building"
    ],
    answer: "B"
  },
  {
    id: 12,
    passageId: "rc2",
    question: "It can be inferred from the passage that:",
    options: [
      "A. Infrastructure spending decisions never consider temperature data",
      "B. Budget priorities may worsen heat inequality between neighborhoods",
      "C. Tree planting has no measurable effect on temperature",
      "D. Wealthy neighborhoods have no parks"
    ],
    answer: "B"
  },
  {
    id: 13,
    passageId: "rc3",
    passage: `The rise of e-commerce has transformed last-mile delivery from a minor logistical detail into a central strategic concern for retailers. Companies now compete not only on price and product range but on delivery speed, prompting investment in micro-warehouses located close to dense urban populations. Critics argue that the push for ever-faster delivery encourages wasteful packaging and increased vehicle emissions, raising questions about whether convenience is being prioritized over environmental cost.`,
    question: "What is the main idea of the passage?",
    options: [
      "A. E-commerce has eliminated the need for warehouses",
      "B. Faster delivery expectations have made last-mile logistics a strategic priority, with environmental trade-offs",
      "C. Retailers no longer compete on price",
      "D. Micro-warehouses have reduced emissions"
    ],
    answer: "B"
  },
  {
    id: 14,
    passageId: "rc3",
    question: "The word 'strategic' in the passage is closest in meaning to:",
    options: [
      "A. Related to careful long-term planning for competitive advantage",
      "B. Accidental",
      "C. Cost-free",
      "D. Unimportant"
    ],
    answer: "A"
  },
  {
    id: 15,
    passageId: "rc3",
    question: "The passage suggests that critics are mainly concerned about:",
    options: [
      "A. Rising product prices",
      "B. Environmental impact of fast delivery",
      "C. Warehouse worker wages",
      "D. Product quality decline"
    ],
    answer: "B"
  },
  {
    id: 16,
    question: "Choose the word closest in meaning to METICULOUS.",
    options: ["A. Careless", "B. Thorough", "C. Hasty", "D. Vague"],
    answer: "B"
  },
  {
    id: 17,
    question: "Choose the antonym of ABUNDANT.",
    options: ["A. Plentiful", "B. Scarce", "C. Generous", "D. Large"],
    answer: "B"
  },
  {
    id: 18,
    question: "Choose the word closest in meaning to GREGARIOUS.",
    options: ["A. Shy", "B. Sociable", "C. Angry", "D. Tired"],
    answer: "B"
  },
  {
    id: 19,
    question: "Choose the antonym of BENEVOLENT.",
    options: ["A. Kind", "B. Malevolent", "C. Generous", "D. Charitable"],
    answer: "B"
  },
  {
    id: 20,
    question: "Which sentence is grammatically correct?",
    options: [
      "A. Neither of the answers are correct.",
      "B. Neither of the answers is correct.",
      "C. Neither of the answer is correct.",
      "D. Neither of the answers were correct."
    ],
    answer: "B"
  },
  {
    id: 21,
    question: "Which sentence is grammatically correct?",
    options: [
      "A. She don't like coffee.",
      "B. She doesn't likes coffee.",
      "C. She doesn't like coffee.",
      "D. She not like coffee."
    ],
    answer: "C"
  },
  {
    id: 22,
    question: "Choose the correct preposition: He is good ___ mathematics.",
    options: ["A. in", "B. at", "C. on", "D. with"],
    answer: "B"
  },
  {
    id: 23,
    question: "Fill in the blank: By the time we arrived, the movie _____ already started.",
    options: ["A. has", "B. have", "C. had", "D. having"],
    answer: "C"
  },
  {
    id: 24,
    question: "Fill in the blank: He is allergic ___ peanuts.",
    options: ["A. from", "B. to", "C. with", "D. of"],
    answer: "B"
  },
  {
    id: 25,
    question: "Choose the correctly spelt word.",
    options: ["A. Recieve", "B. Receive", "C. Receve", "D. Receeve"],
    answer: "B"
  },
  {
    id: 26,
    question: "Choose the correctly spelt word.",
    options: ["A. Neccessary", "B. Necesary", "C. Necessary", "D. Neccessery"],
    answer: "C"
  },
  {
    id: 27,
    question: "Choose the one-word substitute for 'a person who is difficult to please'.",
    options: ["A. Fastidious", "B. Generous", "C. Amiable", "D. Naive"],
    answer: "A"
  },
  {
    id: 28,
    question: "Choose the one-word substitute for 'one who loves mankind'.",
    options: ["A. Philanthropist", "B. Philatelist", "C. Philosopher", "D. Pharmacist"],
    answer: "A"
  },
  {
    id: 29,
    question:
      "Arrange the sentences P, Q, R, S in the correct order to form a coherent paragraph.\nP. However, this convenience comes at a cost to personal privacy.\nQ. Smartphones have made everyday tasks remarkably convenient.\nR. Many apps track user location and behavior continuously.\nS. As a result, users often unknowingly trade privacy for ease of use.",
    options: ["A. QPRS", "B. QRPS", "C. PQRS", "D. QPSR"],
    answer: "A"
  },
  {
    id: 30,
    question: "The idiom 'to let the cat out of the bag' means:",
    options: [
      "A. To adopt a pet",
      "B. To reveal a secret unintentionally",
      "C. To cause confusion",
      "D. To finish a task quickly"
    ],
    answer: "B"
  }
];

export default matLanguageComprehension;